import { CROP_LIST } from "../../helpers/constants";
import MultipleInput from "../elements/MultipleInput";

const CreateRegionPage =()=>{
    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">
                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Regions</h5>
                                    </div>
                                </li>
                                <span className="mx-2 text-gray-400">/</span>
                                <li aria-current="page">
                                    <div className="flex items-center">
                                    <h5 className=" card-title ">Create</h5>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div  className=" h-fit flex-grow flex flex-col justify-center ">
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 "> Names</label>
                            <input type="text" id="name" className="form-input-2" placeholder=""/>
                        </div>
                    
                        <div className="w-2/3 mt-4">
                            <button   type="button" className="prim-btn-2 mb-2">Save</button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateRegionPage;